function Navbar() {
    return (
      <>
        <nav
          className="navbar navbar-expand-lg"
          data-bs-theme="dark"
          style={{ backgroundColor: "#FD913C" }}
        >
          <div className="container-fluid">
            <a
              className="navbar-brand"
              href="/"
              style={{ fontWeight: 990, fontSize: 24 }}
            >
              PointsHub-Admin
            </a>
          </div>
        </nav>
      </>
    );
  }
  
  export default Navbar;
  